// src/dataGenerator.js

// CONFIGURATION DES ZONES (Les lignes de métro principales)
const TRACK_ZONES = {
  dev: { base_y: 0, color: '#8E44AD', label: 'Engineering' },       // Violet
  data: { base_y: 400, color: '#D35400', label: 'Data & AI' },      // Orange
  product: { base_y: 800, color: '#27AE60', label: 'Product' },     // Vert
  design: { base_y: 1100, color: '#E91E63', label: 'Design' },      // Rose
};

// CONFIGURATION DES PONTS (Passerelles entre familles)
const BRIDGES = [
  { source: 'dev_back_mid', target: 'data_eng', color: '#D35400' }, // Backend -> Data Eng
  { source: 'dev_front_sr', target: 'design_system', color: '#E91E63' }, // Front -> Design System
  { source: 'data_analyst', target: 'product_po', color: '#27AE60' }, // Data Analyst -> PO
  { source: 'product_head', target: 'dev_cto', color: '#2C3E50' },   // CPO -> CTO (Move Exec)
];

// DÉFINITION DES ARBRES DE CARRIÈRE
// x: Niveau de séniorité (0 à 10)
// lane: Décalage vertical (-1: monte, 0: milieu, 1: descend)
const CAREER_TREES = [
  {
    track: 'dev',
    nodes: [
      { id: 'dev_intern', x: 0, lane: 0, label: 'Intern' },
      { id: 'dev_jr', x: 1, lane: 0, label: 'Junior Dev' },
      // Fork
      { id: 'dev_front_mid', x: 2, lane: -1, label: 'Frontend Dev' },
      { id: 'dev_back_mid', x: 2, lane: 1, label: 'Backend Dev' },
      { id: 'dev_full_mid', x: 2, lane: 0, label: 'Fullstack Dev' },
      // Seniority
      { id: 'dev_front_sr', x: 3, lane: -1, label: 'Senior Front' },
      { id: 'dev_back_sr', x: 3, lane: 1, label: 'Senior Back' },
      { id: 'dev_lead', x: 4, lane: 0, label: 'Tech Lead' }, // Merge partiel
      { id: 'dev_architect', x: 5, lane: -1, label: 'Architect' },
      { id: 'dev_em', x: 5, lane: 1, label: 'Eng. Manager' },
      // Final
      { id: 'dev_cto', x: 7, lane: 0, label: 'CTO' },
    ],
    connections: [
      ['dev_intern', 'dev_jr'],
      ['dev_jr', 'dev_front_mid'], ['dev_jr', 'dev_back_mid'], ['dev_jr', 'dev_full_mid'],
      ['dev_front_mid', 'dev_front_sr'], ['dev_back_mid', 'dev_back_sr'], ['dev_full_mid', 'dev_lead'],
      ['dev_front_sr', 'dev_lead'], ['dev_back_sr', 'dev_lead'],
      ['dev_lead', 'dev_architect'], ['dev_lead', 'dev_em'],
      ['dev_architect', 'dev_cto'], ['dev_em', 'dev_cto']
    ]
  },
  {
    track: 'data',
    nodes: [
      { id: 'data_intern', x: 0, lane: 0, label: 'Data Intern' },
      { id: 'data_analyst', x: 1, lane: -0.5, label: 'Data Analyst' },
      { id: 'data_eng', x: 2, lane: 1, label: 'Data Engineer' }, // Rejoint par le pont Dev
      { id: 'data_scientist', x: 3, lane: -0.5, label: 'Data Scientist' },
      { id: 'data_lead', x: 4, lane: 0, label: 'Lead Data' },
      { id: 'data_head', x: 6, lane: 0, label: 'Head of Data' },
    ],
    connections: [
      ['data_intern', 'data_analyst'], ['data_intern', 'data_eng'],
      ['data_analyst', 'data_scientist'],
      ['data_eng', 'data_lead'], ['data_scientist', 'data_lead'],
      ['data_lead', 'data_head']
    ]
  },
  {
    track: 'product',
    nodes: [
      { id: 'product_apm', x: 1, lane: 0, label: 'APM' },
      { id: 'product_po', x: 2, lane: 0, label: 'Product Owner' },
      { id: 'product_pm', x: 3, lane: 0, label: 'Product Mgr' },
      { id: 'product_senior', x: 4, lane: 0, label: 'Senior PM' },
      { id: 'product_head', x: 6, lane: 0, label: 'CPO' },
    ],
    connections: [
      ['product_apm', 'product_po'], ['product_po', 'product_pm'],
      ['product_pm', 'product_senior'], ['product_senior', 'product_head']
    ]
  },
  {
    track: 'design',
    nodes: [
      { id: 'design_ui', x: 1, lane: -0.5, label: 'UI Designer' },
      { id: 'design_ux', x: 1, lane: 0.5, label: 'UX Researcher' },
      { id: 'design_product', x: 3, lane: 0, label: 'Product Designer' },
      { id: 'design_system', x: 4, lane: -1, label: 'Design Ops' },
      { id: 'design_head', x: 6, lane: 0, label: 'Head of Design' },
    ],
    connections: [
      ['design_ui', 'design_product'], ['design_ux', 'design_product'],
      ['design_product', 'design_head'], ['design_product', 'design_system']
    ]
  }
];

export const generateMapData = () => {
  const nodes = [];
  const edges = [];

  const X_STEP = 250;     // Espacement horizontal
  const LANE_HEIGHT = 100; // Espacement vertical des branches

  // 1. GÉNÉRER LES ARBRES (LIGNES PRINCIPALES)
  CAREER_TREES.forEach(tree => {
    const zone = TRACK_ZONES[tree.track];

    // Label de Zone (Gros texte à gauche)
    nodes.push({
      id: `zone_${tree.track}`,
      type: 'groupLabel', // Type par défaut ou custom
      data: { label: zone.label },
      position: { x: -250, y: zone.base_y },
      style: { fontSize: '30px', fontWeight: '900', color: zone.color, width: 300, border: 'none', background: 'transparent' },
      selectable: false
    });

    // Nodes
    tree.nodes.forEach(n => {
      nodes.push({
        id: n.id,
        type: 'metroStation',
        data: { label: n.label, familyColor: zone.color }, // On passe la couleur pour le style
        position: { x: n.x * X_STEP, y: zone.base_y + (n.lane * LANE_HEIGHT) },
        style: { zIndex: 10 }
      });
    });

    // Edges (Lignes internes)
    tree.connections.forEach(([src, tgt]) => {
      edges.push({
        id: `e_${src}_${tgt}`,
        source: src,
        target: tgt,
        type: 'smoothstep',
        pathOptions: { borderRadius: 40 },
        style: { stroke: zone.color, strokeWidth: 20, opacity: 0.6 },
        selectable: false
      });
    });
  });

  // 2. GÉNÉRER LES PONTS (BRIDGES)
  BRIDGES.forEach((bridge, i) => {
    edges.push({
      id: `bridge_${i}`,
      source: bridge.source,
      target: bridge.target,
      type: 'smoothstep',
      animated: true, // Animé pour montrer que c'est une mobilité
      style: {
        stroke: bridge.color,
        strokeWidth: 6, // Plus fin que les lignes principales
        strokeDasharray: '10 5', // Pointillés
        opacity: 0.8
      },
      label: 'Bridge', // Petit label optionnel
      labelStyle: { fill: bridge.color, fontWeight: 700 }
    });
  });

  return { nodes, edges };
};